import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

const MAGIC_LINK_APP_LINK = 'magiclink';

@Injectable()
export class Auth0MagicLinkRedirectGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const code = route.queryParamMap.get('code');
    const error = route.queryParamMap.get('error');
    if (!code && !error) {
      return true;
    }

    if (!this.isMagicLinkAppLink(route)) {
      return true;
    }

    return this.router.createUrlTree(['/auth0/magic-link'], {
      queryParams: route.queryParams,
    });
  }

  private isMagicLinkAppLink(route: ActivatedRouteSnapshot): boolean {
    const appLink = route.queryParamMap.get('applink') ?? route.queryParamMap.get('AppLink');
    if (appLink?.trim().toLowerCase() === MAGIC_LINK_APP_LINK) {
      return true;
    }

    const deepLinkValue = route.queryParamMap.get('deep_link_value');
    return deepLinkValue != null && deepLinkValueContainsMagicLink(deepLinkValue);
  }
}

function deepLinkValueContainsMagicLink(deepLinkValue: string): boolean {
  const candidates = [deepLinkValue];
  try {
    candidates.push(decodeURIComponent(deepLinkValue));
  } catch {
    //use raw value only
  }

  for (const candidate of candidates) {
    if (candidate.trim().toLowerCase().includes('applink=magiclink')) {
      return true;
    }

    const queryStart = candidate.indexOf('?');
    if (queryStart < 0) {
      continue;
    }

    const innerQuery = candidate.slice(queryStart + 1);
    for (const part of innerQuery.split('&')) {
      const eq = part.indexOf('=');
      if (eq < 0) {
        continue;
      }
      const key = decodeURIComponent(part.slice(0, eq)).trim().toLowerCase();
      const value = decodeURIComponent(part.slice(eq + 1)).trim().toLowerCase();
      if (key === 'applink' && value === MAGIC_LINK_APP_LINK) {
        return true;
      }
    }
  }

  return false;
}
